export default "__VITE_ASSET__C9sE_fkp__"